export class ThemeRuntime {
	constructor(modules = []) {
		this.modules = modules;
		this.initialized = false;
	}

	bootstrap() {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
			return;
		}

		this.init();
	}

	async init() {
		if (this.initialized) {
			return;
		}

		this.initialized = true;

		for (const moduleInstance of this.modules) {
			if (!moduleInstance || typeof moduleInstance.init !== 'function') {
				continue;
			}

			await moduleInstance.init();
		}
	}
}
